import React from 'react';

const RadioBox = ({ id, label, name, required, checked, onChange, className = '', labelClassName = 'pl-4', value }) => {
  return (
    <div className={`custom-control custom-radio ${className}`}>
      <input
        id={id}
        name={name}
        onChange={onChange}
        type='radio'
        className='custom-control-input'
        required={required}
        checked={checked}
        value={value}
      />
      {label && (
        <label className={`custom-control-label ${labelClassName}`} htmlFor={id}>
          {label}
        </label>
      )}
    </div>
  );
};

export default RadioBox;
